import { render, staticRenderFns } from "./CustomerStatisticsList.vue?vue&type=template&id=fff279c8&scoped=true"
import script from "./CustomerStatisticsList.vue?vue&type=script&lang=js"
export * from "./CustomerStatisticsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff279c8",
  null
  
)

export default component.exports